import Form from 'components/form';
import PhoneInput from 'components/form/PhoneInput';
import React from 'react';
import { validatePhone } from 'utils/index';
import { useForm } from './Form';
const { FormItem } = Form;

const Phone = ({ id, required, inputProps, ...props }) => {
  const { getFieldDecorator } = useForm();

  return (
    <FormItem>
      {getFieldDecorator(id, {
        rules: [
          { required, message: 'Required' },
          { validator: validatePhone },
        ],
      })(
        <PhoneInput
          {...props}
          fullWidth
          inputProps={inputProps}
          margin="dense"
          placeholder="(555) 555-5555"
        />,
      )}
    </FormItem>
  );
};

export default Phone;
